<template>
  <div class="app-container">
    <!-- 查询 -->
    <app-search>
      <div slot="content">
        <el-row :gutter="10" type="flex" justify="start" align="middle">
          <el-col :span="6">
            <el-form :label-position="'right'" :model="listQuery" :label-width="$t('public.licensePlatewidth1')">
              <el-form-item :label="$t('public.licensePlate')+'：'">
                <el-input v-model="listQuery.licensePlate" filterable clearable :placeholder="$t('public.licensePlate')" />
              </el-form-item>
            </el-form>
          </el-col>

          <el-col :span="12">
            <el-form
              :label-position="'right'"
              :model="listQuery"
              label-width="50px"
            >
              <el-form-item :label="$t('statistical.operation.month')+'：'">
                <el-row type="flex" justify="start" align="middle">
                  <el-col :span="12">
                    <el-date-picker
                      v-model="listQuery.beginTime"
                      filterable
                      clearable
                      :placeholder="$t('public.startTime')"
                      type="date"
                      value-format="yyyy-MM-dd"
                      prefix-icon="el-icon-date"
                    />
                  </el-col>
                  &emsp;<span class="time-span" style="color:#ddd;">——</span>&emsp;
                  <el-col :span="12">
                    <el-date-picker
                      v-model="listQuery.endTime"
                      filterable
                      clearable
                      :placeholder="$t('public.endTime')"
                      type="date"
                      value-format="yyyy-MM-dd"
                      prefix-icon="el-icon-date"
                    />
                  </el-col>
                </el-row>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
        
      </div>
      <!-- 清空查询按钮 -->
      <app-search-button
        slot="bottom"
        :is-collapse="false"
        @click-filter="handleFilter"
        @click-clear="handleClear"
      />
    </app-search>
    <!-- 按钮 -->
    <app-authorize-button
      :data="authouizeList"
      @click-filter="showfilter=true"
      @click-export="handleExport"
    >
      <checked-Filter
        slot="check-filter"
        :show.sync="showfilter"
        :list="tableList"
        :scroll-line="8"
      />
    </app-authorize-button>
    <!-- table -->
    <el-table
      v-loading="listLoading"
      size="mini"
      :data="list"
      :max-height="tableHeight"
      :header-row-style="headerRowStyle"
      :row-style="rowStyle"
      :header-cell-style="headerCellStyle"
      border
      fit
      highlight-current-row
      style="width: 100%"
      @sort-change="sortChange"
      @row-click="rowClick"
    >
      <el-table-column :label="$t('table.id')" align="center" width="65">
        <template slot-scope="scope">
          <span>{{ (scope.$index+1)+(listQuery.pageNum -1)*listQuery.pageSize }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(item,index) in filterTableList"
        :key="index"
        :label="item.value"
        :prop="item.prop"
        :align="item.position"
        :min-width="item.width"
        :sortable="item.sortable"
      >
        <template slot-scope="scope">
          <!-- 如果需要特性化显示可使用v-if，v-else-if，v-else-->
             <div v-if="item.prop==='licensePlate'" >
             <div class="url-style">
            <vue-licenseplate
             style="cursor: pointer"
              :licensepalte="scope.row[item.prop]"
              :area="scope.row['areaName']"
            />
             </div>
          </div>
          <div v-else-if="item.prop==='mileageTotal' || item.prop==='timeTotal' || item.prop==='oilTotal' || item.prop==='carbonTotal'">
            <span>
              {{scope.row[item.prop] | fixedText(item.prop) }}
            </span>
          </div>
          <div v-else-if="item.prop==='oilCostTotal'">
            <span>
              {{scope.row[item.prop] | oilText(item.prop) }}
            </span>
          </div>
          <div v-else-if="item.prop==='ecuVin'">
            <span>{{ scope.row[item.prop] || scope.row[item.prop] === 0 ? scope.row[item.prop] : '--' }}</span>
          </div>
          <div v-else>
            <span>{{ scope.row[item.prop] || scope.row[item.prop] === 0 ? scope.row[item.prop] : '/' }}</span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div :class="[total>0?'visible':'hidden','pagination-container']">
      <el-pagination
        :current-page="listQuery.pageNum"
        :page-sizes="[10,20,30,50]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

      <!-- 车辆当天行程详细 -->
    <real-dialog
      :visibles.sync="realVisible"
      :data="tableRow"
    />

  </div>
</template>

<script>
// 混入
import { partialForm } from '@/mixins/partialForm'
import { pagingMixin } from '@/mixins/table'
import { otherHeight } from '@/mixins/getOtherHeight'
import { tableStyle } from '@/mixins/tableStyle'
import { getPageButton } from '@/mixins/getButton'
import realDialog from './components/realDialog'
// request
import {
  getCarInfo,
  exportCar
} from '@/api/vehicletravel/mileageStatistics'
// 辅助函数
export default {
  name: 'mileageStatistics',
  filters: {
    fixedText(val) {
      return (val/1).toFixed(1) || '/'
    },
    oilText(val) {
      return (val/1).toFixed(2) || '/'
    }
  },
  mixins: [pagingMixin, partialForm, otherHeight, tableStyle, getPageButton],
  components: {realDialog},
  data() {
    return {
      listQuery: {
        licensePlate: '', // 车牌号
        barCode: '', // OBD设备号
        beginTime: '', // 开始时间
        endTime: '' // 结束时间
      },
      showfilter: false,
      realVisible:false,
      tableRow:{},
      tableList: [
        {
          value: this.$t('statistical.operation.month'),
          width: '100px',
          prop: 'day',
          position: 'center',
          sortable: 'custom',
          checked: true
        },
        {
          value: this.$t('public.licensePlate'),
          width: '180px',
          prop: 'licensePlate',
          position: 'center',
          sortable: 'custom',
          checked: true
        },
        { value: this.$t('carManagement.regVin'),
          prop: 'vinNo', 
          position: 'center',
          width: '150px', 
          sortable: 'custom',
          checked: true 
        },
        { value: this.$t('carManagement.ecuVin'), 
          prop: 'ecuVin',
          position: 'center',
          width: '150px',
          sortable: 'custom',
          checked: true
        },
        {
          value: this.$t('statistical.operation.aperationMileage'),
          width: '100px',
          prop: 'mileageTotal',
          position: 'center',
          sortable: 'custom',
          checked: true
        },
        {
          value: this.$t('statistical.operation.aperationTiemLenthen'),
          width: '100px',
          prop: 'timeTotal',
          position: 'center',
          sortable: 'custom',
          checked: true
        },
        {
          value: this.$t('statistical.operation.oil'),
          width: '150px',
          prop: 'oilTotal',
          position: 'center',
          sortable: 'custom',
          checked: true
        },
        {
          value: this.$t('statistical.operation.oilPay'),
          width: '110px',
          prop: 'oilCostTotal',
          position: 'center',
          sortable: 'custom',
          checked: true
        },
        {
          value: this.$t('statistical.operation.carbonEmission'),
          width: '150px',
          prop: 'carbonTotal',
          position: 'center',
          sortable: 'custom',
          checked: true
        },
        {
          value: this.$t('statistical.operation.tripCount'),
          width: '120px',
          prop: 'tripCount',
          position: 'center',
          sortable: 'custom',
          checked: false
        },
        // {
        //   value: this.$t('statistical.operation.score'),
        //   width: '180px',
        //   prop: 'score',
        //   position: 'center',
        //   checked: false
        // },
        {
          value: this.$t('statistical.operation.emergencyBrake'),
          width: this.$t('statistical.operation.emergencyBrakeWidth'),
          prop: 'rapidDecelerationTotal',
          position: 'center',
          sortable: 'custom',
          checked: false
        },
        {
          value: this.$t('statistical.operation.rapidAcceleration'),
          width: this.$t('statistical.operation.rapidAccelerationWidth'),
          prop: 'rapidAccelerationTotal',
          position: 'center',
          sortable: 'custom',
          checked: false
        },
        {
          value: this.$t('statistical.operation.sharpturn'),
          width: this.$t('statistical.operation.sharpturnWidth'),
          prop: 'sharpTurnTotal',
          position: 'center',
          sortable: 'custom',
          checked: false
        }
      ],
      authouizeList: [],
      tableHeight: 0,
      total: 0,
      list: [],
      listLoading: false
    }
  },
  computed: {
    filterTableList() {
      return this.tableList.filter(item => item.checked)
    }
  },
  mounted() {

  },
  methods: {
        // 点击列
    rowClick(row, column) {
      const label = column.label
      this.tableRow = row
      //车牌号码
      if (label === this.$t("public.licensePlate")) {
        this._realtimeData(row)
      }
    },

    // 加载数据
    listLoad() {
      this.listLoading = true
      getCarInfo(this.listQuery).then(({ data }) => {
        if (data.code === 0) {
          this.list = data.data
          this.total = data.total
          const orderSort = 'day,licensePlate,barCode'
          this.setOrderField(orderSort, this.tableList)
        }
        this.listLoading = false
      })
      .catch(()=> {
        this.listLoading = false
      })
    },
    // 导出
    handleExport() {
      exportCar(this.listQuery).then(({ data }) => {
        if (data.code === 0) {
          //
        }
      })
    },
        // 车辆当天行程详细
    _realtimeData(row) {
      this.tableRow = row
      this.realVisible = true
    },
  }
}

</script>
<style  lang='scss'>
.url-style{
  *{
    color:#409eff!important;
  }
  .licenseplate{
    border: 2px solid #409eff!important;
  }
}
</style>
